import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Spinner } from "views/Hoc/Spinner";
import { SelectAutocomplete } from '_components/FormElements/FormInput';

import AwardS3VideoItem from "./AwardS3VideoItem";
import AwardVideoItemMENA from "./AwardVideoItem_MENA24";
import { useForm } from "react-hook-form";
import {Card,CardBody, Row,Col, CardHeader} from "reactstrap";

const Event_Pdf_Template = ({ eventId }) => {


    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [catArr, setCatArr] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
     const [catList, setCatList] = useState([]);
const { control } = useForm({ mode: 'onBlur' });
    const TemplateData = async () => {
        await axios.get('/channelAdmin/Pdf_Template/' + eventId).then(res => {
            if (res.data.length) {
                setData(res.data);
            }
        });
    }

    useEffect(() => {

        (async () => {
            setLoading(true);
            await TemplateData();
            await TemplateVideoData();
            setLoading(false);
        })();


    }, [])
    const TemplateVideoData = async () => {
        console.log('testing data : TemplateVideoData ')
        await axios.get('/channelAdmin/Video_Template/' + eventId).then(res => {
            if (res.data.length) {
                setCatList(res.data);
                let catOption = []
                let checkArr = []
                res.data.map((x)=>{
                    if (checkArr.indexOf(x.category) === -1 && x.category !== '')
                    {   checkArr.push(x.category);
                        catOption.push({'name':x.category}) 
                    } 
                    
                });
                catOption = catOption.filter(function(item, pos, self) {
                    
                    return self.indexOf(item) == pos;
                }) 
                setCatArr(catOption)
            }
        });        
    }
    
    // Function to get filtered list
    function getFilteredList() {
        // Avoid filter when selectedCategory is null
        if (!selectedCategory) {
            return catList;
        }
        let filteredItem = catList.filter((item) => item.category === selectedCategory);
        console.log('filteredItem : ', filteredItem)
       
        filteredItem.sort((a, b) => a.order - b.order);
        console.log('filteredItem : ', filteredItem)
        return filteredItem
    }
    var filteredList = useMemo(getFilteredList, [selectedCategory, catList]);
    const handleCategoryChange = (input, value) => {
        console.log(input, value)
        if(!value?.name){
            setSelectedCategory(null);
        } else {
            setSelectedCategory(value.name);
        }        
    }
    catArr.map((element, index) => {
        console.log('catArr element : ', element.name)
        console.log('catArr index : ', index)
    });
    return (
        <>
            {(loading && data.length > 0) ? <Spinner /> :

                <div className='picvideo-wrap'>
                    <div className='row'>
                        {data.map(item =>
                            <div style={{ margin: "20px" }}>
                                <div className='menapic-wrap'>
                                    <div className='menapic-img'>
                                        <img src={item.logo} />
                                    </div>
                                    <span style={{ paddingLeft: "15px", fontSize: "18px", color: "#333" }}>{item.title}</span><br />
                                    <a className='btn btn-primary' style={{ marginTop: "20px", marginLeft: "20px" }} download={item.title} href={item.pdfPath} id="downloadClick" title={item.title} >{item.buttonLabel}</a>

                                </div>
                            </div>
                        )}
                    </div>
                </div>
            }

             {/* <Card className="item-container">
                <div className='row'>                                    
                <div className='col-sm-6'>
                    
                    
                    <div><span><b>Filter by Category:1</b></span>
                    <SelectAutocomplete
                        id="category-list"
                        type="text"                
                        label="Category"
                        name="category-list"                
                        options={catArr}
                        placeholder="Category"
                        getOptionSelected={(options, value) => options.name === value.name}
                        disableCloseOnSelect
                        limitTags={2}
                        style={{width:"27%"}}
                        control={control}                         
                        input='category-list'
                        handleChangeSelect={handleCategoryChange}
                    />   </div> 
                    
                
                </div> </div>
                </Card>
            {(loading && catList.length > 0) ? '' : <div className="cat-list">
            
                {(selectedCategory == null || selectedCategory == '' && catArr.length > 0) ? catArr.map(x=>(
                    <div className="">
                    <Row className="align-items-center">
                        <Col lg="12" md="12" sm="12" >
                        <div class='set-image h-100' style={{ height: "100% !important", marginTop: "56px", padding: "14px"}}>
                        <h2  style={{ color:"#2566e8"}}>{x.name}</h2> 
                        </div>
                        </Col>
                            {(catList.filter((item) => item.category === x.name)).sort((a, b) => a.order - b.order).map((element, index) => (
                        
                                  
                                <AwardS3VideoItem {...element} key={index} /> 
                                    

                            ))} 

                        
                    </Row>
                    </div>
                    )) :
                    <>
                    <div className="">
                    <Row className="align-items-center">
                        <Col lg="12" md="12" sm="12" >
                        <div class='set-image h-100' style={{ height: "100% !important", marginTop: "56px", padding: "14px"}}>
                        <h2  style={{ color:"#2566e8"}}>{selectedCategory}</h2> 
                        </div>
                        </Col>
                    {filteredList.map((element, index) =>  ( 
                        
                                    
                                <AwardS3VideoItem {...element} key={index} /> 
                              
                             
                    ))} </Row></div></>

                    }
            </div> } */}
            <Card className="item-container" style={{"padding": '20px 50px  70px 60px'}}>
            <h2><img src="https://farm66.staticflickr.com/65535/buddyicons/67672940@N05.jpg?1775206059#67672940@N05" alt="Channel Hub Events" width="48" height="48"/>   &nbsp;Channel Summit META 2026</h2>
            <Row style={{padding: '30px 0 0 0'}}>
              
                <Col lg="3" md="3" sm="2" >
                    <div  class="setThumPicture">
                        <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336084334/' title='click here to view META 2026 Setup & Registration' target='_blank'>
                        <img class="setThumb" src="https://live.staticflickr.com/65535/55578929291_cab13708f0_s.jpg" width="75" height="75" alt="META 2026 Setup &amp; Registration"/>                       
                        </a>
                    </div>
                    <div>
                    <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336084334/' title='click here to view META 2026 Setup & Registration' target='_blank'>
                        <h3>META 2026 Setup <br/>& Registration</h3>
                    </a>
                    </div>
                </Col>
                <Col lg="3" md="3" sm="2" >    
                        <div  class="setThumPicture">
                            <a href='https://www.flickr.com/photos/67672940@N05/sets/72177720336073083/' title='click here to view META 2026: Exhibition Area' target='_blank'>
                                <img class="setThumb" src="https://live.staticflickr.com/65535/55577911272_2238765bd0_s.jpg" width="75" height="75" alt="META 2026: Exhibition Area"/>
                            </a>
                            
                        </div>
                        <div>
                        <a href='https://www.flickr.com/photos/67672940@N05/sets/72177720336073083/' title='click here to view META 2026: Exhibition Area' target='_blank'>
                            <h3>META 2026: Exhibition Area</h3>
                        </a>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="2" >
                        <div  class="setThumPicture">
                            <a href='https://www.flickr.com/photos/67672940@N05/sets/72177720336060316/' title='click here to view META 2026 Keynote & Best Product Awards' target='_blank'>
                                <img class="setThumb" src="https://live.staticflickr.com/65535/55579094909_e76713c0a0_s.jpg" width="75" height="75" alt="META 2026 Keynote &amp;<br/>Best Product Awards"/>
                            </a>
                        </div>
                        <div>
                            <a href='https://www.flickr.com/photos/67672940@N05/sets/72177720336060316/' title='click here to view META 2026 Keynote & Best Product Awards' target='_blank'>                       
                                <h3>META 2026 Keynote &<br/> Best Product Awards</h3>
                            </a>
                        </div>

                    </Col>
                    <Col lg="3" md="3" sm="2" >
                        <div  class="setThumPicture">
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336060271/' title='click here to view META 2026 Panel discussion' target='_blank'>
                            <img class="setThumb" src="https://live.staticflickr.com/65535/55579055213_0c784a19a4_s.jpg" width="75" height="75" alt="META 2026 Panel discussion "/>
                            </a>
                        </div>
                        <div>
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336060271/' title='click here to view META 2026 Panel discussion' target='_blank'>
                                <h3>META 2026 Panel<br/> discussion</h3>
                            </a>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="2" >
                        <div  class="setThumPicture">
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336059566/' title='click here to view META 2025 ECSF' target='_blank'>
                            <img class="setThumb" src="https://live.staticflickr.com/65535/55578938456_b37c683a4d_s.jpg" width="75" height="75" alt="META 2025 ECSF"/>
                            </a>
                        </div>
                        <div>
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336059566/' title='click here to view META 2025 ECSF' target='_blank'>
                            <h3>META 2026 ECSF</h3>
                            </a>
                        </div>
                    </Col>
                    <Col lg="3" md="3" sm="2" >
                        <div  class="setThumPicture">
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336054070/' title='click here to view META 2026 Gala Dinner & Awards' target='_blank'>
                            <img src="https://live.staticflickr.com/65535/55578935626_a74aa28664_s.jpg"  width="75" height="75" alt="META 2026 Gala Dinner &amp; Awards"/>
                            </a>
                        </div>
                        <div>
                            <a href='https://www.flickr.com/photos/67672940@N05/albums/72177720336054070/' title='click here to view META 2026 Gala Dinner & Awards' target='_blank'>
                            <h3>META 2026 Gala <br/>Dinner & Awards</h3>
                            </a>
                        </div>
                    </Col>
                
            </Row>
            </Card>

        </>
    )
}
export default Event_Pdf_Template;